module.exports = __webpack_public_path__ + "img/novideo.8fc18ea2.png";